import axios from './_axios_config';
import { request } from './_process_request';

export const ct_meta = {
    async getOptions() {
        return request(axios.get('/options'));
    },

    async getNotifications() {
        return request(axios.get('/notifications'));
    },
};
